<template>
<div class="events">
    <vue-headful title="Events" />
    <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-3': true}">

        <v-row no-gutters>
            <!-- service filter-->
            <v-col cols="12" md="3" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Services</div>
                    <im-search-services class="im-select" @input="filterService($event)" ref="services" label="Any" :hide-details="true" />
                </v-card>
            </v-col>
            <!--./ service filter-->
        </v-row>

        <!-- SEARCH -->
        <div class="im-search mt-3 mb-1">
            <div class="d-flex">
                <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable placeholder="Type here to search by field ..." append-icon="search" hide-details></v-text-field>
                <v-icon v-if="$vuetify.breakpoint.smAndDown" class="px-1" medium @click="dialog_mobile_sort = true">swap_vert</v-icon>
            </div>
            <div class="d-flex mx-1 py-2 fields align-center">
                <span class="detail mr-1 hidden-sm-and-down">Find in:</span>
                <v-btn v-for="field in search_fields" :key="field.value" smal rounded depressed :color="field.selected ? 'primary' : 'grey lighten-2'" :text-color="field.selected ? 'white' : 'grey'" @click="selectField(field)">
                    <span class="text-capitalize caption">{{field.text}}</span>
                </v-btn>
            </div>
        </div>
        <!-- ./ SEARCH -->

        <!--data table-->
        <v-card tile flat class="mx-1">
            <im-table-header class="mt-2" :items="im_header" @clickSort="sortField($event)" />
        </v-card>
        <!--./ data table -->
        <div class="mx-1" style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>

        <!-- DATATABLE ROWS -->
        <v-card tile flat class="mx-1" style="background-color: transparent !important;">
            <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                <template v-slot:default="props">
                    <template v-for="item in props.items">
                        <im-event-card :item="item" :listeners="all_listeners" :key="item.id" @click.native="seeItem(item)"></im-event-card>
                    </template>
                </template>
                <template v-slot:no-data>
                    <v-alert :value="true" type="info" color="primary">
                        No data available.
                    </v-alert>
                </template>
            </v-data-iterator>
        </v-card>
        <!-- ./ DATATABLE ROWS -->

    </v-container>

    <!-- dialog user -->
    <v-dialog v-model="dialog_event" width="920" persistent max-height="600" :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-card>
            <v-card flat tile>
                <v-card-title class="headline p-2">
                    Event Details
                    <v-spacer />
                    <v-btn icon left @click="dialog_event=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
            </v-card>
            <im-event-modal :item="current_event" :listeners="all_listeners" />
            <v-card-actions>
                <v-btn dark class="mx-1" color="red" @click="openDeleteModal()">
                    Delete
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="mx-1" color="primary" @click="openEdit()">
                    Edit
                </v-btn>
                <v-btn text class="mx-1" @click="dialog_event=false">
                    Cancel
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
    <!-- ./ dialog user -->

    <!-- ADD ITEM DIALOG -->
    <v-dialog v-model="add_dialog" max-width="50%" persistent :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-card color="secondary">
            <v-card-title class="title primary white--text">
                Event
            </v-card-title>
            <v-card-text class="pa-2">
                <div class="px-2 py-1">
                    <v-card class="elevation-1 pa-1">
                        <div class="detail font-weight-bold pa-0 ma-0">Service</div>
                        <im-search-services class="im-select" :service_slug="item.service" ref="services_modal" label="Select service" :hide-details="true" @input="selectService($event)" />
                    </v-card>
                </div>
                <div class="px-2 py-1">
                    <v-card class="elevation-1 pa-1">
                        <div class="detail font-weight-bold pa-0 ma-0">Slug</div>
                        <v-text-field v-model="item.slug" class="im-select ma-0" solo flat clearable placeholder="The event slug (new-hotel)." hide-details />
                    </v-card>
                </div>
                <div class="px-2 py-1">
                    <v-card class="elevation-1 pa-1">
                        <div class="detail font-weight-bold">Listeners</div>
                        <v-select multiple chips flat solo v-model="item.listeners" :items="all_listeners" item-text="text" item-value="value" placeholder="Attach listeners." clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                            hide-details />
                    </v-card>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn dark depressed color="red" @click="openDelete(item)">
                    <v-icon>delete</v-icon>
                </v-btn>
                <v-spacer />
                <v-btn color="primary" text @click="add_dialog=false">Cancel</v-btn>
                <v-btn color="primary" :loading="loading_save" @click="saveItem()">Submit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ ADD ITEM DIALOG -->

    <!-- DELETE ITEM DIALOG -->
    <v-dialog v-model="delete_dialog" max-width="20%">
        <v-card>
            <v-card-text class="pt-2">
                Are you sure you want to delete this event?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="delete_dialog=false">
                    Cancel
                </v-btn>
                <v-btn dark depressed color="red" :loading="loading_delete" @click="deleteItem()">
                    Delete
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./ DELETE ITEM DIALOG -->

    <!-- ADD ITEM BUTTON -->
    <v-btn color="primary" fab large fixed bottom right @click="openCreate()">
        <v-icon>add</v-icon>
    </v-btn>
    <!-- ./ ADD ITEM BUTTON -->
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../components/utils/PropDefaults.js";
import IMEventCard from '../../components/items/EventCard.vue';
import IMTableHeader from '../../components/utils/IMTableHeader.vue';
import IMSortField from "../../components/utils/IMSortField.vue";
import SearchServices from "../../components/utils/SearchServices.vue";
import IMEventModal from '../../components/items/EventModal.vue';


export default {

    components: {
        'im-event-card': IMEventCard,
        'im-table-header': IMTableHeader,
        'im-sort-filed': IMSortField,
        'im-search-services': SearchServices,
        'im-event-modal': IMEventModal
    },

    data() {
        return {
            current_event: defaults.event_item,
            add_dialog: false,
            delete_dialog: false,
            edit_dialog: false,
            loading_save: false,
            loading_delete: true,
            // table items
            item: {
                service: null,
                slug: null,
                listeners: [],
            },
            items: [],
            services: [],
            all_listeners: [],

            //search
            search: null,

            filters: {
                service: null,
            },

            search_fields: [
                {
                    text: 'Service',
                    value: 'service',
                    selected: true
                }, {
                    text: 'Slug',
                    value: 'slug',
                    selected: true
                }, {
                    text: 'Listeners',
                    value: 'listeners.path',
                    selected: true
                }
            ],

            //im-header
            im_header: [
                {
                    text: "Id",
                    width: "8.3%",
                    sortable: true,
                    sort_order: 'id',
                    sort_dir: 'desc',
                }, {
                    text: "Service",
                    width: "25%",
                    sortable: true,
                    sort_order: 'service',
                    sort_dir: null,
                }, {
                    text: "Slug",
                    width: "25%",
                    sortable: true,
                    sort_order: 'slug',
                    sort_dir: null,
                }, {
                    text: "Listeners",
                    width: "41.7%",
                    sortable: false,
                },
            ],

            dialog_event: false,
            sort_field_item: 'id',
            sort_field_dir: 'desc',
            dialog_mobile_sort: false,


            // table attributes
            loading: null,
            total: 0,
            page: 1,
            size: 10,
            itemsPerPageOptions: [10, 25, 50, 100],
        }
    },

    created() {
        this.getServices();
        this.getAllListeners();
        this.getItems();
    },

    watch: {

        page: {
            handler() {
                this.getItems();
            }
        },
        size: {
            handler() {
                this.getItems();
            }
        },

        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems, 500)
            }
        }

    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        getServices() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/roles/services";

            let params = {
                params: {
                    size: 1000
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    let services = [];
                    response.data.data.forEach(function (item) {
                        services.push({
                            text: item.name,
                            value: item.slug,
                        })
                    });
                    this.services = services;
                })
                .catch(error => {
                    console.log(error);
                    this.showError('Oops, something went wrong.')
                })

        },

        getAllListeners() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/event-bus/all-listeners";

            this.$axios.get(endpoint)
                .then(response => {
                    let all_listeners = [];
                    response.data.forEach(function (item) {
                        all_listeners.push({
                            text: item.service + ':' + item.path,
                            value: item.id,
                        });
                    });
                    this.all_listeners = all_listeners;
                })
                .catch(error => {
                    console.log(error);
                    this.showError('Oops, something went wrong.')
                })

        },

        getItems() {

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/event-bus/events";

            // switch state to loading
            this.loading = true;

            // prepare search string
            let search = this.search;
            if(search === "" || search === undefined) {
                search = null;
            }

            //prepare sorting & direction params
            let orders = null;
            let dirs = null;
            if(this.sort_field_item) {
                dirs = this.sort_field_dir;
                orders = this.sort_field_item;
            }

            // prepare type filter
            let fields = '';
            this.search_fields.forEach(field => {
                if(field.selected)
                    fields += field.value + ';';
            });

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query params
            let params = {
                params: {
                    service: this.filters.service,
                    search: search,
                    searchFields: fields,
                    size: this.size,
                    page: this.page,
                    order: orders,
                    sort: dirs,
                    stamp: stamp
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    if(parseInt(this.current_stamp) === parseInt(response.data.meta.stamp)) {
                        this.items = response.data.data;
                        this.total = response.data.pagination.total;
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.showError('Oops, something went wrong.')
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        saveItem() {
            this.loading_save = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/event-bus/events';

            // call update or save endpoints
            if(this.item.id) {

                this.$axios.put(endpoint + '/' + this.item.id, this.item)
                    .then(() => {
                        this.page = 1;
                        this.getItems();
                        this.success('Event updated.');
                        this.add_dialog = false;
                    })
                    .catch(error => {
                        console.error(error);
                        this.error("Oops, something went wrong!");
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });

            } else {

                this.$axios.post(endpoint, this.item)
                    .then(() => {
                        this.page = 1;
                        this.getItems();
                        this.success('Event created.');
                        this.add_dialog = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.error("Oops, something went wrong!");
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });

            }
        },

        deleteItem() {
            this.loading_delete = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/event-bus/events';

            // call delete endpoint
            this.$axios.delete(endpoint + '/' + this.delete_item.id)
                .then(() => {
                    this.page = 1;
                    this.getItems();
                    this.success('Event deleted.');
                    this.add_dialog = false;
                    this.delete_dialog = false;
                })
                .catch(error => {
                    console.error(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {
                    this.loading_delete = false;
                });
        },

        openCreate() {
            this.$refs.services_modal.clear();
            this.item = {
                service: null,
                slug: null,
                listeners: [],
            };
            this.add_dialog = true;
        },

        openEdit() {
            this.add_dialog = true;
            this.item = Object.assign({}, this.current_event);
            this.dialog_event = false;
        },

        openDeleteModal() {
            this.dialog_event = false;
            this.delete_item = Object.assign({}, this.current_event);
            this.delete_dialog = true;
        },

        selectField(field) {
            field.selected = !field.selected;
            if(this.search) {
                this.page = 1;
                this.getItems();
            }
        },

        sortField(sortItem) {
            this.sort_field_item = sortItem.sort_order;
            this.sort_field_dir = sortItem.sort_dir;
            this.page = 1;
            this.getItems();
            this.dialog_mobile_sort = false;
        },

        seeItem(current_item) {
            this.current_event = current_item;
            this.dialog_event = true;
        },


        filterService(service) {
            if(service) {
                this.filters.service = service.slug;
            } else {
                this.filters.service = null;
            }
            this.page = 1;
            this.getItems();
        },

        selectService(value) {
            if(value.slug) {
                this.item.service = value.slug;
            }
        }

    }
}
</script>

<style>
.im-select .v-select__slot {
    cursor: pointer;
}
</style>
